import {IconName, Intent as BJSIntent, Position} from '@blueprintjs/core';
import {Bulk} from '@mintdata/mint-kit/api/models/Bulk';
import {IconId, IconIds} from '@mintdata/mint-kit/api/models/IconId';
import {InlinePlacement} from '@mintdata/mint-kit/api/models/InlinePosition';
import {Intent} from '@mintdata/mint-kit/api/models/Intent';
import {Side} from '@mintdata/mint-kit/api/models/Side';
import {ABoolean} from '@mintdata/mint-kit/api/values/ABoolean';
import {AString} from '@mintdata/mint-kit/api/values/AString';

export class BJSUtil
{
    public static toIsMinimal(isFlat:ABoolean):string
    {
        if( isFlat.value )
            return 'pt-minimal';
        else
            return '';
    }

    public static toSizeClass(value:Bulk | ABoolean):string
    {
        if( Bulk.isBulk(value) )
        {
            if( !value || !value.value )
                return '';

            if( value.isEqualTo(Bulk.small()) )
                return 'pt-small';
            else if( value.isEqualTo(Bulk.large()) )
                return 'pt-large';
            else
                return '';
        }

        if( value.value )
        {
            return 'pt-large';
        }
        else
        {
            return '';
        }
    }

    public static toPlacementClass(inlinePlacement:InlinePlacement):string
    {
        if( !inlinePlacement || !inlinePlacement.value )
            return '';

        if( inlinePlacement.isEqualTo(InlinePlacement.left()) )
            return 'pt-align-left';
        else if( inlinePlacement.isEqualTo(InlinePlacement.right()) )
            return 'pt-align-right';
        else return '';
    }

    public static toIsVertical(isVertical:ABoolean):string
    {
        if( isVertical.value )
            return 'pt-vertical';
        else
            return '';
    }

    public static toBJSIconName(iconId:IconId):IconName
    {
        if( !iconId || !iconId.value )
            return null;

        if( IconId.fromString(IconIds.BLANK).isEqualTo(iconId) )
            return null;

        return iconId.toString() as IconName;
    }

    public static toBJSPosition(side:Side):Position.LEFT | Position.RIGHT
    {
        if( side.value.value === Side.left().value.value )
            return Position.LEFT;

        if( side.value.value === Side.right().value.value )
            return Position.RIGHT;
    }

    public static toBJSIntentCssClass(intent:Intent):string
    {
        if( !intent || !intent.value )
            return '';

        const i:AString = intent.value;

        if( Intent.SUCCESS.isEqualTo(i) )
            return 'pt-intent-success';
        else if( Intent.WARNING.isEqualTo(i) )
            return 'pt-intent-warning';
        else if( Intent.PRIMARY.isEqualTo(i) )
            return 'pt-intent-primary';
        else if( Intent.DANGER.isEqualTo(i) )
            return 'pt-intent-danger';
        else
            return '';
    }

    public static toBJSIntent(intent:Intent):BJSIntent
    {
        if( !intent || !intent.value )
            return BJSIntent.NONE;

        const i:AString = intent.value;

        if( Intent.SUCCESS.isEqualTo(i) )
            return BJSIntent.SUCCESS;
        else if( Intent.WARNING.isEqualTo(i) )
            return BJSIntent.WARNING;
        else if( Intent.PRIMARY.isEqualTo(i) )
            return BJSIntent.PRIMARY;
        else if( Intent.DANGER.isEqualTo(i) )
            return BJSIntent.DANGER;
        else
            return BJSIntent.NONE;
    }

    public static isBlankIcon(name:string):boolean
    {
        return name === 'pt-icon-blank';
    }
}
